import type { ReactNode } from 'react';
import { LucideProvider } from 'lucide-react';

/**
 * Traço padrão dos ícones Lucide do backoffice: 1,5, como manda o livro de
 * marca (capítulo 8). Sem o provider, todo ícone sem `strokeWidth` sai com o 2
 * da biblioteca. Quem passa `strokeWidth` explícito vence o padrão (exceções
 * nomeadas do livro: 2 em seta e chip de 12 px, 2,5 no spinner).
 */
export function IconDefaults({ children }: { children: ReactNode }) {
  return <LucideProvider strokeWidth={1.5}>{children}</LucideProvider>;
}
